var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadBannerDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4667 7.06621H7.06667C6.71111 7.06621 6 7.27954 6 8.13287C6 8.98621 6 17.0218 6 20.9329C6 21.2884 6.35556 21.9995 7.77778 21.9995C9.2 21.9995 16.4296 21.9995 19.8667 21.9995C20.2222 21.9995 20.9333 21.644 20.9333 20.2218C20.9333 18.7995 20.9333 15.8366 20.9333 14.5329",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19.0957L10.4357 15.0296C10.745 14.746 11.2175 14.7381 11.5362 15.0113L16.7852 19.5105",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1259 17.4365L17.106 15.4564C17.3979 15.1645 17.8601 15.1316 18.1904 15.3794L20.9333 17.4365",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1588 10.6218C20.1407 10.6218 20.9366 9.82583 20.9366 8.84399C20.9366 7.86215 20.1407 7.06621 19.1588 7.06621C18.177 7.06621 17.381 7.86215 17.381 8.84399C17.381 9.82583 18.177 10.6218 19.1588 10.6218Z",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.157 6V7.06667",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.157 10.6229V11.6896",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.227 6.71135L20.4727 7.46559",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6686 10.2664L16.9144 11.0207",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0245 6.71135L17.7788 7.46559",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5764 10.2664L21.3307 11.0207",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3116 8.84375H16.8449H17.3783",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9329 8.84375H21.4662H21.9995",
    stroke: "#A0A9BE",
    strokeWidth: 1.65926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBannerDisabled);
export default __webpack_public_path__ + "static/media/upload-banner-disabled.9578d6f835ef0c9357464dc761ef5eda.svg";
export { ForwardRef as ReactComponent };